import i18n from 'src/utils/i18n/i18n';
import { object, string } from 'yup';

export default {
  validation: object().shape({
    email: string().required(i18n.t('SIGN_IN_FILL_REQUIRED_FIELD')),
    password: string().min(8).required(i18n.t('SIGN_IN_FILL_REQUIRED_FIELD')),
  }),
  requireValues: ['email', 'password'],
};
